import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/facturacion/facturaFEL';
import FacturaB from './FacturaInventarioFELTabs';


const ms2p = (state) => {
  return {
    ...state.factura_fel,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(FacturaB);
